import {TrackAddPaymentInfoDto} from "@app/core/tracking/domain/dtos/track-add-payment-info.dto";
import {TrackedItemMapper} from "@app/core/tracking/infrastructure/mappers/tracked-item.mapper";
import {PaymentMethodType} from "@app/core/delivery-point/application/dtos/payment-method-type";

const CARD = 'tarjeta';

export class TrackAddPaymentInfoDtoMapper {
    static serialize(params: TrackAddPaymentInfoDto) {
        return {
            currency: params.currency,
            value: params.value,
            ...(params.paymentType === PaymentMethodType.VISA ? {payment_type: CARD} : {}),
            ...(params.coupon !== undefined ? {coupon: params.coupon} : {}),
            items: params.items.map(item => TrackedItemMapper.serialize(item)),
        }
    }
}
